// Stops Chrome's own suggestion dropdowns on the app's text inputs. Chrome has
// two of them, and no single autocomplete value turns off both:
//  - History ("values you typed before"), looked up by the input's name:
//    only autocomplete="off" disables it; any other value re-enables it.
//  - Address/contact autofill ("Manage addresses..."), picked from the field's
//    label (e.g. "... / Phone No / Email"): Chrome ignores "off" here and only
//    backs off for an autocomplete token it doesn't recognise.
// So inputs with a name (react-hook-form / InputUI fields, which Chrome keys
// history on) keep "off", and inputs without one (MUI Autocomplete search /
// select fields, keyed only by React's generated id) get the unrecognised
// token. Attribute-only: values, events and form behaviour are untouched.
// Password fields, non-text inputs and inputs with a deliberate autocomplete
// value (e.g. "email", "username") are left as they are.
const NO_AUTOFILL = "nbl-no-autofill";
const TEXT_TYPES = ["text", "email", "tel", "search", "url", "number"];

const fix = (el) => {
  if (el.tagName !== "INPUT" || !TEXT_TYPES.includes(el.type)) return;
  const current = el.getAttribute("autocomplete");
  if (current && current !== "off" && current !== NO_AUTOFILL) return;
  const wanted = el.name ? "off" : NO_AUTOFILL;
  if (current !== wanted) el.setAttribute("autocomplete", wanted);
};

const fixTree = (node) => {
  if (node.nodeType !== 1) return;
  fix(node);
  node.querySelectorAll?.("input").forEach(fix);
};

export const disableBrowserAutofill = () => {
  fixTree(document.body);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      if (m.type === "attributes") fix(m.target);
      else m.addedNodes.forEach(fixTree);
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    // React re-applies its own value if a field's props change, and some
    // inputs get their name/type after mounting; re-check on those changes.
    attributes: true,
    attributeFilter: ["autocomplete", "name", "type"],
  });
};
